import React from "react";
import DecorativeSquares from "../../components/ui/DecorativeSquares";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const ViewSubsPlan = () => {
  const navigate = useNavigate();
  return (
    <>
      <section className="relative max-w-7xl xl:max-w-6xl 2xl:max-w-5xl mx-auto px-4 md:px-6 py-10 pb-32 md:pb-10">
        <DecorativeSquares />

        {/* ================= HEADER ================= */}
        <div className="flex items-center justify-between bg-white px-5 md:px-6 py-4 rounded-2xl shadow-sm">
          <button
            onClick={() => navigate("/profile/subscription-plan")}
            className="p-2 rounded-full hover:bg-gray-100 transition"
          >
            <FaArrowLeft size={20} />
          </button>

          <h1 className="text-lg md:text-2xl font-semibold text-gray-900">
            View Subscription Plan
          </h1>

          <div className="w-10" />
        </div>

        {/* ================= CONTENT ================= */}
        <div className="mt-10 flex justify-center">
          <div className="w-full md:w-[85%]">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
              {/* Item 1 */}
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <h2 className="text-lg font-bold text-[#191919]">
                    Active Customers
                  </h2>
                  <span className="text-sm font-semibold text-[#191919] bg-gray-100 px-4 py-1.5 rounded-full">
                    10
                  </span>
                </div>

                <p className="text-sm text-[#969495] leading-relaxed">
                  Maximum number of customers you can manage in the app.
                </p>

                <div className="border-b border-gray-100" />
              </div>

              {/* Item 2 */}
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <h2 className="text-lg font-bold text-[#191919]">
                    Active Customers
                  </h2>
                  <span className="text-sm font-semibold text-[#191919] bg-gray-100 px-4 py-1.5 rounded-full">
                    100
                  </span>
                </div>

                <p className="text-sm text-[#969495] leading-relaxed">
                  Maximum number of customers you can manage in the app.
                </p>

                <div className="border-b border-gray-100" />
              </div>

              {/* Item 3 */}
              <div className="space-y-2 md:col-span-2">
                <h2 className="text-lg font-bold text-[#191919]">
                  Active Customers
                </h2>

                <p className="text-sm text-[#969495] leading-relaxed">
                  Maximum number of customers you can manage in the app.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ViewSubsPlan;
